import type { StaffChangePasswordInput } from '@icebreaker/shared/staff';
import { api } from '@/shared/api/client';

/**
 * PERSONEL ŞİFRESİ — `api` katmanı, YALNIZCA sagalardan çağrılır (eslint
 * `no-api-in-ui`).
 *
 * "Durum sorma" (`panelStatus`) ucu YOKTUR ve gerekmez (panel kimliği ayrımı ·
 * Karar 1): o uç "bu ÜRÜN oturumunun panel şifresi kurulu mu" sorusunu
 * yanıtlıyordu. İki tablo olunca soru ortadan kalktı — `staff_sessions`ta bir
 * satır olmak panel oturumu olmaktır ve şifresi olmayan hesap zaten giriş
 * yapamaz (ilk şifre DAVETLE kurulur).
 */

export function changeStaffPassword(input: StaffChangePasswordInput): Promise<void> {
  return api.staff.changePassword(input);
}
